import {
  IColumn,
  ImageIcon,
  TooltipHost,
  TooltipOverflowMode,
} from "@fluentui/react";
import link from "../../pages/CollectionDetail/assets/link.svg";
import { IIngestionDefinition } from "types/stac";

//include the column displayName, text
export const IngestionNameColumn: IColumn = {
  key: "displayName",
  name: "Name",
  fieldName: "displayName",
  minWidth: 130,
  isResizable: true,
  onRender: (item: IIngestionDefinition) => (
    <span>
      <ImageIcon style={{ height: 24, marginRight: 8 }} imageProps={{ src: link }} />
      <TooltipHost
        content={item.displayName}
        overflowMode={TooltipOverflowMode.Parent}
      >
        <span style={{ verticalAlign: "top" }}>
          {item.displayName || "(no name)"}
        </span>
      </TooltipHost>
    </span>
  ),
};

export const IngestionIdColumn: IColumn = {
  key: "id",
  name: "Ingestion ID",
  fieldName: "ingestionId",
  minWidth: 170,
  isResizable: true,
  onRender: (item: IIngestionDefinition) => (
    <TooltipHost content={item.id} overflowMode={TooltipOverflowMode.Parent}>
      <span>{item.id}</span>
    </TooltipHost>
  ),
};
